import { AsyncThunkPayloadCreator, SerializedError, createAsyncThunk } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';

interface TypedAsyncThunkConfig<RejectValue> {
  state: AppStateType;
  rejectValue: RejectValue;
}

export function createTypedAsyncThunk<ReturnedType = any, ArgType = void, RejectValue = SerializedError>(
  typePrefix: string,
  payloadCreator: AsyncThunkPayloadCreator<ReturnedType, ArgType, TypedAsyncThunkConfig<RejectValue>>,
  options?: Parameters<typeof createAsyncThunk<ReturnedType, ArgType, TypedAsyncThunkConfig<RejectValue>>>[2],
) {
  return createAsyncThunk<ReturnedType, ArgType, TypedAsyncThunkConfig<RejectValue>>(
    typePrefix,
    payloadCreator,
    options,
  );
}
